import { render } from "./RoadmapLeftColumn.vue?vue&type=template&id=84fef548&scoped=true"
import script from "./RoadmapLeftColumn.vue?vue&type=script&lang=js"
export * from "./RoadmapLeftColumn.vue?vue&type=script&lang=js"

import "./RoadmapLeftColumn.vue?vue&type=style&index=0&id=84fef548&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-84fef548"

export default script